<div class="row" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'"
  style="padding: 5px !important; margin-bottom: 5px !important;">
  <div class="padding5 b-radius control-bar" [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-light-blue'">
    <div class="col-6 flex unset-p flex align-centre">
      <select #ddl class="font14 unset-b padding5 b-radius unset-outline cursorPointer"
        [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary textWhite' : 'bg-white textBlack'" (change)="selectValue($event)">
        <option class="cursorPointer textBlack" [value]="0">{{translations.GBL_lbl_SelectOption}}</option>
        <ng-container *ngFor="let val of mainData">
          <option class="cursorPointer textBlack" [value]="val.id" [selected]="val.id == keyValue">
            {{val.value}}
          </option>
        </ng-container>
      </select>
      <ng-template [ngIf]="masterConfig && keyValue">
        <button class="btn font17" (click)="openColumnDialog()">
          <fa-icon [icon]="faTableColumns" class="padding3 b-radius textGreen control-bar-btn-icon"></fa-icon>
          <span class="control-bar-btn-text"
            [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{translations.GBL_btn_ColumnsText}}</span>
        </button>
        <div class="relative" (mouseenter)="showAdvancedFiltersButton = true"
          (mouseleave)="showAdvancedFiltersButton = false">
          <button class="btn font17" (click)="toggleFilters()">
            <fa-icon [icon]="faFilter" class="textGreen padding3 b-radius control-bar-btn-icon"></fa-icon>
            <span class="control-bar-btn-text"
              [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{translations.GBL_btn_FilterText}}</span>
          </button>
          <ng-template [ngIf]="showAdvancedFiltersButton">
            <div class="absolute box-shadow b-radius" style="top: 35px;" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
              <button class="btn font17" (click)="openAdvancedFilters()">
                <fa-icon [icon]="faPlus" class="padding3 b-radius textGreen control-bar-btn-icon"></fa-icon>
                <span class="control-bar-btn-text" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                  {{translations.GBL_btn_AdvancedFiltersText}}
                </span>
              </button>
            </div>
          </ng-template>
        </div>
        <button class="btn font17" (click)="exportData()">
          <fa-icon [icon]="faFileExport" class="padding3 b-radius textGreen control-bar-btn-icon"></fa-icon>
          <span class="control-bar-btn-text"
            [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{translations.GBL_btn_Export}}</span>
        </button>
      </ng-template>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12 relative">
    <p-table [columns]="headers" [reorderableColumns]="false" styleClass="p-datatable-gridlines"
      [resizableColumns]="false">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let header of headers">
            <ng-container *ngFor="let filter of filters">
              <ng-template [ngIf]="header.visible && header.caption == filter.caption">
                <th class="fit-content-max-width" (dblclick)="sort(undefined)"
                  (contextmenu)="openContextMenu($event, header)"
                  [ngClass]="['padding' + settings.globalPadding, 'font' + settings.textSizeSetting, settings.darkModeSetting ? 'bg-transparent': 'bg-white']">
                  <span class="word-break" (click)="sort(header)" [ngClass]="{'sorted-column': header.sortedBy, 
                'active-filter': filter.isActive && !settings.darkModeSetting, 
                'active-filter-dark': filter.isActive && settings.darkModeSetting,
                'textGreyb9': filter.isNull, 
                'textBlack': !filter.isNull && !settings.darkModeSetting, 
                'textWhite': !filter.isNull && settings.darkModeSetting,
                'cursorPointer': header.displayFormat != 'IMAGE',
                'cursorNotAllowed': header.displayFormat == 'IMAGE'}">
                    <ng-template [ngIf]="sortString && header.sortedBy">
                      <fa-icon [icon]="sortOrder ? faArrowUpLong : faArrowDownLong"
                        [ngClass]="['font' + settings.textSizeSetting, 'padding' + settings.globalPadding]"></fa-icon>
                    </ng-template>
                    {{header.caption}}
                  </span>
                </th>
              </ng-template>
            </ng-container>
          </ng-container>
        </tr>
        <ng-template [ngIf]="showFilters">
          <tr>
            <ng-container *ngFor="let header of headers">
              <ng-container *ngFor="let filter of filters">
                <ng-template [ngIf]="header.visible && header.caption == filter.caption">                 
                  <ng-template [ngIf]="filter.displayFormat == 'TIME' || filter.displayFormat.includes('DATE')">
                    <td (dblclick)="clearFilter(filter)" class="relative cursorPointer"
                      [ngClass]="['padding' + settings.globalPadding, settings.darkModeSetting ? 'bg-dark' : 'bg-white']"
                      (contextmenu)="nullifyFilter(filter, $event)">
                      <button class="absolute bg-none unset-p unset-b range-filter-btn" tooltipPosition="top"
                        [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack']" (click)="op.toggle($event)"
                        pTooltip="{{getFilterTooltip(filter)}}" #inputRef
                        [tooltipDisabled]="!filter.isActive  || filter.isNull">
                        <fa-icon [icon]="faDownLeftAndUpRightToCenter"></fa-icon>
                      </button>
                      <ng-template [ngIf]="filter.isNull">
                        <span class="font14 italic textGreyb9" style="padding-left: 5px;">(null)</span>
                      </ng-template>
                      <p-overlayPanel #op>
                        <ng-template pTemplate="content">
                          <div class="b-radius box-shadow" style="padding: 20px 0px 10px;"
                            [ngClass]="[settings.darkModeSetting ? 'bg-dark' : 'bg-white']">
                            <div class="row">
                              <div class="col-12">
                                <span class="font15 padding5 b-radius"
                                  [ngClass]="[settings.darkModeSetting ? 'textWhite bg-dark-secondary' : 'textBlack bg-light-blue']">
                                  {{translations.GBL_lbl_ChooseRange}}
                                </span>
                                <ng-template [ngIf]="filter.isNull">
                                  <span class="font14 italic textGreyb9" style="padding-left: 5px;">(null)</span>
                                </ng-template>
                              </div>
                            </div><br />
                            <div class="row">
                              <div class="col-6">
                                <span class="font12" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                                  {{translations.GBL_lbl_RangeFrom}}
                                </span><br>
                                <ng-template [ngIf]="filter.displayFormat == 'TIME'">
                                  <input class="form-control textBlack font14 input-filter" step=60 type="time" #txtTo
                                    [(ngModel)]="filter.ranges.from" />
                                </ng-template>
                                <ng-template [ngIf]="filter.displayFormat != 'TIME'">
                                  <date-picker (dateSelected)="fromDateUpdated($event, filter)"
                                    [filterFromValue]="filter.ranges.userDateFrom" [settings]="settings"></date-picker>
                                </ng-template>
                              </div>
                              <div class="col-6">
                                <span class="font12" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                                  {{translations.GBL_lbl_RangeTo}}
                                </span><br>
                                <ng-template [ngIf]="filter.displayFormat == 'TIME'">
                                  <input class="form-control textBlack font14 input-filter" step=60 type="time" #txtTo
                                    [(ngModel)]="filter.ranges.to" />
                                </ng-template>
                                <ng-template [ngIf]="filter.displayFormat != 'TIME'">
                                  <date-picker (dateSelected)="toDateUpdated($event, filter)"
                                    [filterToValue]="filter.ranges.userDateTo" [settings]="settings"></date-picker>
                                </ng-template>
                              </div>
                            </div><br />
                            <div class="row">
                              <div class="col-12 flex justify-right">
                                <button class="btn font17" (click)="createRangeFilter(filter)">
                                  <fa-icon [icon]="faCheck"
                                    class="textGreen padding3 b-radius control-bar-btn-icon"></fa-icon>
                                  <span class="control-bar-btn-text"
                                    [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{translations.GBL_btn_ApplyText}}</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </p-overlayPanel>
                    </td>
                  </ng-template>
                  <ng-template [ngIf]="filter.displayFormat == 'CHECK'">
                    <td (dblclick)="clearFilter(filter)"
                      [ngClass]="['padding' + settings.globalPadding, settings.darkModeSetting ? 'bg-dark' : 'bg-white']">
                      <mat-checkbox #chk [checked]="preSelectCheckBoxFilter(filter)"
                        [indeterminate]="filter.isNull" (change)="updateValue(chk.value, filter, $event)"
                        (contextmenu)="nullifyFilter(filter)" #inputRef>
                      </mat-checkbox>
                    </td>
                  </ng-template>
                  <ng-template [ngIf]="filter.displayFormat == '' || filter.displayFormat == 'string' 
                    || filter.displayFormat == 'IMAGE' || header.displayFormat == 'HTML'">
                    <td (dblclick)="clearFilter(filter)" class="relative"
                      [ngClass]="['padding' + settings.globalPadding, settings.darkModeSetting ? 'bg-dark' : 'bg-white']">
                      <input class="form-control b-radius input-filter" type="text" #txtFilter
                        [ngClass]="['font' + settings.textSizeSetting, 'padding' + settings.globalPadding, settings.darkModeSetting ? 'textWhite' : 'textBlack']"
                        placeholder="..." (keyup)="updateValue(txtFilter.value, filter, $event)"
                        [disabled]="header.displayFormat == 'IMAGE' || filter.dataType == 'Byte[]' || (!filteredByEditableFilterString && showAdvancedFilters)"
                        [value]="header.field == filter.field ? filter.value : ''" #inputRef
                        (click)="focusFilter(filter)" (contextmenu)="openContextMenu($event, filter)" />
                      <ng-template [ngIf]="filter.showHistory && filter.filteredHistory.length > 0 && settings.filterHistorySetting">
                        <div class="box-shadow absolute full-width padding10 text-left b-radius"
                          [ngClass]="settings.darkModeSetting ? 'textWhite bg-dark' : 'textBlack bg-light-blue'">
                          <ng-container *ngFor="let value of filter.filteredHistory">
                            <div class="full-width cursorPointer historyValueContainer padding5 b-radius"
                              (click)="updateFilterFromHistory(value, filter)" style="margin-bottom: 5px">
                              <span class="font13" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{value}}</span>
                            </div>
                          </ng-container>
                        </div>
                      </ng-template>
                    </td>
                  </ng-template>
                </ng-template>
              </ng-container>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template [ngIf]="showAdvancedFilters">
          <tr class="animated fadeIn">
            <td [attr.colspan]="headers.length+1" class="relative"
              [ngClass]="['padding' + settings.globalPadding, settings.darkModeSetting ? 'bg-dark' : 'bg-white']">
              <input #filterInput [value]="editableFilterString" class="form-control input-filter transition4 font13"
                [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'" style="padding: 5px 120px 5px 30px;"
                [ngStyle]="{'border-color': editableFilterStringError.length > 0 ? 'var(--red)' : '#ced4da'}" />
              <ng-template [ngIf]="editableFilterStringError.length > 0">
                <fa-icon [icon]="faInfoCircle"
                  class="padding3 b-radius textRed absolute font14 cursorPointer advancedFilterErrorIcon"
                  pTooltip="{{editableFilterStringError}}" tooltipPosition="top"></fa-icon>
              </ng-template>
              <div class="absolute flex advancedFilterInputButtonContainer">
                <fa-icon [icon]="faFilter" class="padding3 textGreen font15 cursorPointer"
                  (click)="validateFilterString(filterInput.value)" pTooltip="{{translations.GBL_btn_FilterText}}"
                  tooltipPosition="top"></fa-icon>
                <fa-icon [icon]="faArrowUpRightFromSquare" class="padding3 textGreen font15 cursorPointer"
                  (click)="showAdvancedFiltersDialog()"
                  pTooltip="{{translations.GBL_hint_OpenAdvancedFilterDialog}}" tooltipPosition="left"></fa-icon>
                <fa-icon [icon]="faXmark" class="padding3 textGreen font15 cursorPointer"
                  (click)="closeAdvancedFilters()" pTooltip="{{translations.GBL_hint_Close}}"
                  tooltipPosition="top"></fa-icon>
              </div>
            </td>
          </tr>
        </ng-template>
      </ng-template>
    </p-table>
  </div>
</div>
<ng-template [ngIf]="masterConfig && keyValue">
  <div class="row" style="margin-bottom: 10px !important;">
    <div class="col-12">
      <mat-tab-group class="detail-tab-group" [ngClass]="[settings.darkModeSetting ? 'bg-dark' : 'bg-white']"
        [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="changeTab($event)" [@.disabled]="true">
        <ng-container *ngFor="let child of this.masterConfig.childGrids">
          <mat-tab class="relative animated fadeIn">
            <ng-template mat-tab-label>
              <div>
                <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                  style="padding: 10px 30px;">{{child.caption}}</span>
              </div>
            </ng-template>
          </mat-tab>
        </ng-container>
      </mat-tab-group>
    </div>
  </div>
</ng-template>
<div class="row">
  <div [ngClass]="extendedData ? 'col-9' : 'col-3'"
    style="padding: 0px 5px !important; overflow-y: auto !important; max-height: 70vh;">
    <ng-template [ngIf]="lines.length > 0">
      <div class="row">
        <div class="col-10 unset-p">
          <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'" class="font14 animated fadeIn padding10 record-count">
            {{lines.length}} {{translations.GBL_lbl_Rows}}
          </span>
        </div>
        <div class="col-2 unset-p flex justify-right">
          <button class="btn font14" (click)="extendData()" style="margin-bottom: 5px !important;">
            <fa-icon [icon]="extendedData ? faAngleLeft : faAngleRight" class="padding3 b-radius textGreen"></fa-icon>
          </button>
        </div>
      </div>
      <div class="row">
        <ng-container *ngFor="let line of lines">
          <div class="relative" [ngClass]="extendedData ? 'col-4' : 'col-12'">
            <div class="b-radius relative animated fadeIn transition4 font13 tile-container cursorPointer"
              style="margin-bottom: 10px; overflow-y: hidden; padding: 5px 25px 5px 5px;" 
              [ngClass]="[settings.darkModeSetting ? (line.selected ? 'textWhite bg-green' : 'textWhite bg-dark-secondary') : 
                        (!line.selected ? 'textBlack bg-light-blue' : 'textWhite bg-green')]"
              [ngStyle]="{'height': extendedData ? 'auto' : (line.expanded ? 'auto' : '110px')}"
              (click)="selectLines(line)">
              <ng-container *ngFor="let item of line.list | keyvalue">
                <ng-container *ngFor="let header of headers">
                  <ng-template [ngIf]="header.visible && item.key.toString() == header.field">
                    <div>
                      <span class="bold">{{ header.caption }}</span><br>
                      <ng-template [ngIf]="item && (item.key != 'ICON' && item.key != 'IMAGE' 
                        && !item.value.toString().toLowerCase().includes('true') && !item.value.toString().toLowerCase().includes('false')
                        && !item.value.toString().includes('</') && !item.value.toString().includes('<br>'))">
                        <span>
                          <ng-template [ngIf]="item.value.length > 0">{{ item.value }}<br></ng-template>
                          <ng-template [ngIf]="item.value.length == 0">-<br></ng-template>
                        </span>
                      </ng-template>
                    </div>
                    <br>
                  </ng-template>
                </ng-container>
              </ng-container>
            </div>
            <fa-icon [icon]="faChevronDown" class="absolute font14 cursorPointer padding5" (click)="expandTile(line)"
              style="top: 0px; right: 8px; width: fit-content;"
              [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', extendedData ? 'display-none' : 'display-unset']"></fa-icon>
          </div>
        </ng-container>
      </div>
    </ng-template>
    <ng-template [ngIf]="lines.length == 0">
      <span class="font15 padding10 text-centre b-radius inline-block full-width no-records unset-m"
        [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary textWhite' : 'bg-light-blue textBlack'">
        {{translations.GBL_lbl_NoRecords}}
      </span>
    </ng-template>
  </div>
  <div [ngClass]="extendedData ? 'col-3' : 'col-9'" style="padding: 0px 5px !important;">
    <div id="map" style="height: 70vh; width: 100%; max-height: 70vh;"></div>
  </div>
</div>
<div #contextMenu *ngIf="contextMenuVisible" class="fixed padding5 b-radius context-menu box-shadow"
  [ngClass]="settings.darkModeSetting ? 'textWhite bg-dark' : 'textBlack bg-light-blue'"
  [ngStyle]="{ top: contextMenuTop + 'px', left: contextMenuLeft + 'px' }" (click)="contextMenuVisible = false">
  <ng-template [ngIf]="contextMenuType == 'filter'">
    <div style="border-bottom: 1px solid;"
      [ngClass]="settings.darkModeSetting ? 'context-menu-item-dark-border' : 'context-menu-item-light-border'">
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
        (click)="copyValue(contextMenuObject)">
        <fa-icon [icon]="faCopy" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{translations.GBL_hint_Copy}}</span>
      </div>
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
        (click)="pasteValueIntoFilter(contextMenuObject)">
        <fa-icon [icon]="faPaste" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{translations.GBL_lbl_Paste}}</span>
      </div>
    </div>
    <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
      (click)="clearFilter(contextMenuObject)">
      <fa-icon [icon]="faEraser" class="textGreen font13 context-menu-item-icon"></fa-icon>
      <span class="font15">{{translations.GBL_btn_Clear}}</span>
    </div>
    <div class="full-width cursorPointer flex context-menu-item b-radius padding5" (click)="toggleFilters()">
      <fa-icon [icon]="faEraser" class="textGreen font13 context-menu-item-icon"></fa-icon>
      <span class="font15">{{translations.GBL_lbl_ClearAll}}</span>
    </div>
    <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
      (click)="nullifyFilter(contextMenuObject)">
      <fa-icon [icon]="faCircleDot" class="textGreen font13 context-menu-item-icon"></fa-icon>
      <span class="font15">{{translations.GBL_lbl_Nullify}}</span>
    </div>
  </ng-template>
  <ng-template [ngIf]="contextMenuType == 'header'">
    <div style="border-bottom: 1px solid;"
      [ngClass]="settings.darkModeSetting ? 'context-menu-item-dark-border' : 'context-menu-item-light-border'">
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5" (click)="sort(contextMenuObject)">
        <fa-icon [icon]="faUpDown" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{translations.GBL_hint_ColSortText}}</span>
      </div>
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
        (click)="sort(undefined)">
        <fa-icon [icon]="faRemove" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{translations.GBL_lbl_RemoveSort}}</span>
      </div>
    </div>
    <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
      (click)="hideColumn(contextMenuObject)">
      <fa-icon [icon]="faEyeSlash" class="textGreen font13 context-menu-item-icon"></fa-icon>
      <span class="font15">{{translations.GBL_lbl_HideColumn}}</span>
    </div>
  </ng-template>
</div>